import { createAction } from "@reduxjs/toolkit";
import { getCardDetailsActionTypes } from "./actionTypes";

export const getCardDetails = createAction(getCardDetailsActionTypes.request);
export const getCardDetailsSuccess = createAction(
  getCardDetailsActionTypes.success,
);
export const getCardDetailsFailure = createAction(
  getCardDetailsActionTypes.failure,
);
export const getCardDetailsReset = createAction(
  getCardDetailsActionTypes.reset,
);
